function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.63 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "QuoteAlert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.68,22.93a1.9,1.9,0,0,0-1,1,2.1,2.1,0,0,0-.27,1.41,2.64,2.64,0,0,0,.32.82,2.12,2.12,0,0,0,1.78,1,2.73,2.73,0,0,0,1.19-.27,2.23,2.23,0,0,0,1.14-1.42,1.92,1.92,0,0,0-.37-1.46,3,3,0,0,0-2.74-1Zm1.6,2.1c0,.09-.13.23-.36.41a.72.72,0,0,1-.92-.18.64.64,0,0,1,.05-.64.25.25,0,0,1,.23-.09.85.85,0,0,1,.32,0,1.31,1.31,0,0,1,.55.28.18.18,0,0,1,.13.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,9.74a1.43,1.43,0,0,0-.41.09.84.84,0,0,0-.68.86A33,33,0,0,0,15,17a38.7,38.7,0,0,1,.6,4.56.84.84,0,0,0,.41.69.85.85,0,0,0,.59.22h1.55a.78.78,0,0,0,.82-.59.92.92,0,0,0,.1-.36c.13-1.37.32-2.79.45-4.16.23-2.1.5-4.24.69-6.39a1,1,0,0,0-.19-.64.81.81,0,0,0-.64-.27h-.13a26,26,0,0,0-3.84-.37Zm3,2c-.18,1.88-.41,3.75-.64,5.53-.13,1.14-.27,2.23-.41,3.38h-.09a25,25,0,0,0-.5-3.75,41.61,41.61,0,0,1-.64-5.34c.78,0,1.56.09,2.29.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,1.16A.84.84,0,0,0,18.28.7a.93.93,0,0,0-.77-.37,1,1,0,0,0-.78.37,1.65,1.65,0,0,0-.32.46,7.67,7.67,0,0,1-.83,1.41c-.27.46-.54,1-.86,1.42-.55,1-1.14,1.87-1.74,2.83-1.14,1.87-2.33,3.74-3.47,5.61C7.19,16.17,5,20,2.94,23.89,2.4,25,1.81,26.08,1.31,27.22c-.37.86-2.06,3.28-.05,3.51,10.68,1.1,21.31-.22,32-.32a1,1,0,0,0,1.05-1v0a.9.9,0,0,0-.1-.68C30.11,18.91,23.85,10.33,18.6,1.16ZM3.08,28.68c4-8.81,9.54-16.71,14.43-25,4.79,8.17,10.27,16,14.2,24.6-9.54.13-19.08,1.18-28.62.41Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1443e17b18284abeee843002d46f07e7.svg";
export { ForwardRef as ReactComponent };